function initSnakeCanvas(canvas) {
    const context = canvas.getContext("2d");
    const container = canvas.parentElement || document.body;
    const fillColor = canvas.dataset.fillColor || '#ffffff';

    const healDelay = 2500;
    const mouseSmoothness = 0.15;
    const lerpSpeed = 0.08;

    const user = {
        x: 0, y: 0,
        targetX: 0, targetY: 0,
        radius: 0,
        trail: []
    };

    let hasFirstMove = false;
    let isPointerActive = false;
    let pointerX = -1000;
    let pointerY = -1000;
    let isInitialized = false;

    function resize() {
        const rect = container.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;

        if (!isInitialized) {
            user.x = user.targetX = canvas.width / 2;
            user.y = user.targetY = canvas.height / 2;
            isInitialized = true;
        }

        context.globalCompositeOperation = 'source-over';
        context.fillStyle = fillColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }

    new ResizeObserver(resize).observe(container);

    window.addEventListener('pointermove', (e) => {
        pointerX = e.clientX;
        pointerY = e.clientY;
        isPointerActive = true;
    }, { passive: true });

    window.addEventListener('touchstart', (e) => {
        pointerX = e.touches[0].clientX;
        pointerY = e.touches[0].clientY;
        isPointerActive = true;
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
        pointerX = e.touches[0].clientX;
        pointerY = e.touches[0].clientY;
        isPointerActive = true;
    }, { passive: true });

    document.addEventListener('mouseleave', () => { isPointerActive = false; });
    window.addEventListener('blur', () => { isPointerActive = false; });

    window.addEventListener('touchend', () => { isPointerActive = false; }, { passive: true });
    window.addEventListener('touchcancel', () => { isPointerActive = false; }, { passive: true });

    function animate(timestamp) {
        context.globalCompositeOperation = 'source-over';
        context.fillStyle = fillColor;
        context.fillRect(0, 0, canvas.width, canvas.height);

        if (pointerX !== -1000) {
            const rect = canvas.getBoundingClientRect();
            user.targetX = pointerX - rect.left;
            user.targetY = pointerY - rect.top;

            if (!hasFirstMove) {
                user.x = user.targetX;
                user.y = user.targetY;
                hasFirstMove = true;
            }
        }

        const dx = user.targetX - user.x;
        const dy = user.targetY - user.y;

        user.x += dx * mouseSmoothness;
        user.y += dy * mouseSmoothness;

        const frameMoveDist = Math.hypot(dx * mouseSmoothness, dy * mouseSmoothness);

        if (isPointerActive && frameMoveDist > 0.5) {
            const targetRadius = Math.min(Math.max(frameMoveDist * 3 + 48, 48), 140);
            user.radius += (targetRadius - user.radius) * lerpSpeed;
            user.trail.push({ x: user.x, y: user.y, time: timestamp, radius: user.radius });
        } else {
            user.radius += (0 - user.radius) * lerpSpeed;
        }

        user.trail = user.trail.filter(point => timestamp - point.time < healDelay);

        if (user.trail.length > 1) {
            context.globalCompositeOperation = 'destination-out';
            context.fillStyle = 'black';

            for (let i = 0; i < user.trail.length - 1; i++) {
                const p1 = user.trail[i];
                const p2 = user.trail[i + 1];

                const age1 = timestamp - p1.time;
                const age2 = timestamp - p2.time;
                const taper1 = Math.max(0, 1 - (age1 / healDelay));
                const taper2 = Math.max(0, 1 - (age2 / healDelay));

                const r1 = p1.radius * taper1;
                const r2 = p2.radius * taper2;

                const segmentDx = p2.x - p1.x;
                const segmentDy = p2.y - p1.y;
                const segmentDist = Math.hypot(segmentDx, segmentDy);

                const steps = Math.ceil(segmentDist / 2);
                for (let j = 0; j <= steps; j++) {
                    const t = steps === 0 ? 0 : j / steps;
                    const cx = p1.x + segmentDx * t;
                    const cy = p1.y + segmentDy * t;
                    const cr = r1 + (r2 - r1) * t;

                    if (cr > 0.5) {
                        context.beginPath();
                        context.arc(cx, cy, cr / 2, 0, Math.PI * 2);
                        context.fill();
                    }
                }
            }
        }

        requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
}

document.querySelectorAll('.snake-reveal-canvas').forEach(canvas => {
    initSnakeCanvas(canvas);
});